import * as React from 'react';

import {
  getServerSideProps as baseGetServerSideProps,
  GetServerSidePropsType,
} from 'lib/get-server-side-props';
import { isSocialReferrer } from 'lib/is-social-referrer';

import { LandingContainer } from 'containers/project-love/landing/landing-container';

type IndexPageProps = {
  showDownloadHero?: boolean;
};

const IndexPage: React.FunctionComponent<IndexPageProps> = ({ showDownloadHero }) => {
  return <LandingContainer showDownloadHero={showDownloadHero} />;
};

export default IndexPage;

/**
 * Resolved server-side so the right hero is in the initial HTML - reading the
 * param on the client would flash the wrong one above the fold (JS-30122).
 */
export const getServerSideProps = async (context: GetServerSidePropsType) => {
  const result = await baseGetServerSideProps(context);

  if (!('props' in result)) {
    return result;
  }

  return {
    ...result,
    props: {
      ...result.props,
      showDownloadHero: isSocialReferrer(context.query),
    },
  };
};
